// src/pages/EditProfilePage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

/* --- Quick avatar uploader -> POST /me/avatar --- */
function AvatarUploader() {
  const onPick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;

    const fd = new FormData();
    fd.append("avatar", f);

    try {
      await api.post("/me/avatar", fd);
      alert("Profile photo updated");

      // refresh cached user everywhere
      const { data } = await api.get("/me");
      localStorage.setItem("user", JSON.stringify(data.user));

      window.location.reload();
    } catch (err) {
      alert(err?.response?.data?.error || err.message || "Upload failed");
    }
  };

  return (
    <div style={{ margin: "12px 0" }}>
      <label className="btn">
        Choose profile photo
        <input
          type="file"
          accept="image/*"
          onChange={onPick}
          style={{ display: "none" }}
        />
      </label>
    </div>
  );
}

export default function EditProfilePage() {
  const [username, setUsername] = useState("");
  const [bio, setBio] = useState("");
  const [profilePic, setProfilePic] = useState(null);
  const [userId, setUserId] = useState("");
  const [busy, setBusy] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function loadMe() {
      try {
        const { data } = await api.get("/me");
        const u = data.user || {};
        setUsername(u.username || "");
        setBio(u.bio || "");
        setUserId(u.user_id || "");
        localStorage.setItem("user", JSON.stringify(u));
      } catch (err) {
        console.error("loadMe error", err);
        navigate("/login");
      }
    }
    loadMe();
  }, [navigate]);

  function validateUserId(input) {
    return /^[a-z0-9_]{3,30}$/.test(input);
  }

  async function saveProfile(e) {
    e.preventDefault();

    if (!validateUserId(userId)) {
      alert(
        "User id must be 3–30 chars, lowercase letters, numbers or underscore"
      );
      return;
    }

    setBusy(true);
    try {
      const form = new FormData();
      if (username) form.append("username", username);
      if (bio) form.append("bio", bio);
      if (profilePic) form.append("profile_pic", profilePic);
      form.append("user_id", userId);

      await api.put("/me", form);

      // refresh cached user
      const { data } = await api.get("/me");
      localStorage.setItem("user", JSON.stringify(data.user));

      alert("Profile updated!");
      navigate(`/u/${userId}`);
    } catch (err) {
      console.error("update error", err);
      alert(
        err?.response?.data?.error ||
          err.message ||
          "Failed to update profile"
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ padding: 16, maxWidth: 720, margin: "24px auto" }}>
      <h1>Edit Profile</h1>

      <h3 style={{ marginTop: 8 }}>Profile photo</h3>
      <AvatarUploader />

      <form onSubmit={saveProfile}>
        <label style={{ display: "block", marginTop: 8 }}>
          Display name
        </label>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{ width: "100%", padding: 8 }}
        />

        <label style={{ display: "block", marginTop: 8 }}>
          User id / handle
        </label>
        <input
          value={userId}
          onChange={(e) => setUserId(e.target.value.trim())}
          style={{ width: "100%", padding: 8 }}
          placeholder="eg. bksingh"
        />

        <label style={{ display: "block", marginTop: 8 }}>
          Bio
        </label>
        <textarea
          value={bio}
          onChange={(e) => setBio(e.target.value)}
          style={{ width: "100%", padding: 8 }}
        />

        <label style={{ display: "block", marginTop: 8 }}>
          Profile picture (alt method)
        </label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setProfilePic(e.target.files[0] || null)}
        />

        <div style={{ marginTop: 12 }}>
          <button type="submit" disabled={busy}>
            {busy ? "Saving…" : "Save profile"}
          </button>
        </div>
      </form>
    </div>
  );
}